import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import MainPage from "./pages/MainPage";
import ProfilePage from "./pages/ProfilePage";
import UserProfilePage from "./pages/UserProfilePage";
import JobBoardPage from "./pages/JobBoardPage";
import SearchPage from "./pages/SearchPage";
import LoginPage from "./pages/LoginPage";
import ProfileSetupPage from "./pages/ProfileSetupPage";
import ProfileEditPage from "./pages/ProfileEditPage";
import ContactPage from "./pages/ContactPage";
import Footer from "./components/common/Footer";

// QueryClient 생성
const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <div className="flex flex-col min-h-screen">
          <div className="flex-grow">
            <Routes>
              <Route path="/" element={<MainPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/profile-setup" element={<ProfileSetupPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/jobs" element={<JobBoardPage />} />
              <Route path="/profile/:username" element={<ProfilePage />} />
              <Route
                path="/profile/:username/edit"
                element={<ProfileEditPage />}
              />
              <Route path="/user/:username" element={<UserProfilePage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </div>
          <Footer />
        </div>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: "#363636",
              color: "#fff",
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: "#4ade80",
                secondary: "#fff",
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: "#ef4444",
                secondary: "#fff",
              },
            },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  );
}
